import { Link } from "react-router-dom";

interface LogoProps {
  /** true when placed on a dark background */
  light?: boolean;
}

export default function Logo({ light = false }: LogoProps) {
  return (
    <Link
      to="/"
      aria-label="명불허전 수학학원 홈으로 이동"
      className="group flex items-center gap-2.5 cursor-pointer shrink-0"
    >
      <span className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 transition-transform duration-300 group-hover:-rotate-6">
        <span className="font-heading text-xl font-black leading-none text-foreground-950">
          ∑
        </span>
        <span className="absolute -bottom-1 -right-1 h-3.5 w-3.5 rounded-full bg-accent-500 ring-2 ring-primary-950/0" />
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading text-lg font-black tracking-tight ${
            light ? "text-white" : "text-foreground-950"
          }`}
        >
          명불허전
        </span>
        <span className="mt-1 font-label text-[10px] font-medium tracking-[0.18em] text-primary-500">
          MATH ACADEMY
        </span>
      </span>
    </Link>
  );
}